import {IEnumListEntry} from "../definitions";
export const GO_CATEGORIES = {
    ANIMAL: "ANIMAL",
    COMMON_BUILDING: "COMMON_BUILDING",
    HOUSE: "HOUSE",
    ACHIEVEMENT_HOUSE: "ACHIEVEMENT_HOUSE",
    DECOR: "DECOR",
    LIVE_DECOR: "LIVE_DECOR",
    FARM_CELL: "FARM_CELL",
    GARBAGE: "GARBAGE",
    LAIR: "LAIR",
    MARKET: "MARKET",
    PASTURE: "PASTURE",
    PLANT: "PLANT",
    ROAD: "ROAD",
    SHOP_KEEPER: "SHOP_KEEPER",
    STORAGE_COMMON: "STORAGE_COMMON",
    STORAGE_MANA: "STORAGE_MANA",
    STUFF: "STUFF",
    STUFF_PACK: "STUFF_PACK",
    TREE: "TREE",
    ZEPPELIN: "ZEPPELIN",
    LANDSCAPE: "LANDSCAPE",
    SHMU: "SHMU",
    NPC: "NPC",
    SCAFFOLD: "SCAFFOLD",
    BALLOONS: "BALLOONS",
    DIRIGIBLE: "DIRIGIBLE",
    FLYING_CAT: "FLYING_CAT",
    TALKING_HEAD: "TALKING_HEAD",
    ORDERS_HOST: "ORDERS_HOST",
    EVENT_STARTER: "EVENT_STARTER"
};



export const GO_CATEGORIES_LIST:IEnumListEntry[] = Object.keys(GO_CATEGORIES).map(key => {
    return <IEnumListEntry>{ id: GO_CATEGORIES[key], label: key };
});


export const GO_COMPONENTS = {
    BOUNDS: "boundsComponent",
    WORK: "workComponent",
    LAIR: "lairComponent",
    LIMITED: "limitedComponent",
    HOUSE: "houseComponent",
    INITIAL: "initialComponent",
    SHOP: "shopComponent",
    INFLUENCE_SENDER: "influenceSenderComponent",
    INFLUENCE_RECEIVER: "influenceReceiverComponent",
    LIVE_DECOR: "liveDecorComponent",
    FLOATING_COST: "floatingCostComponent",
    RES_TRANSACTION: "resTransactionComponent",
    PASTURE: "pastureComponent",
    RESOURCE: "resourceComponent",
    STORAGE: "storageComponent",
    PLANT: "plantComponent",
    MOVE: "moveComponent",
    TALKING_HEAD: "talkingHead",
    TAGS: "tagsComponent",
    GAME_EVENTS: "gameEventsComponent",
    ORDERS: "ordersComponent",
    EVENT_STARTER: "eventStarterComponent",
    RENDER: "renderComponent",
    GAME_TASK: "gameTaskComponent",
    PERIODICAL_REWARD: "periodicalRewardComponent"
};

export const GO_ACTION_TYPES = {
    EAT_Place: 0,
    EAT_LevelUp: 1,
    EAT_Remove: 2,
    EAT_Produce: 3,
    EAT_Repair: 4,
    EAT_Sowing: 5,
    EAT_Explore: 6,
    EAT_LevelDown: 7
};

export const GO_ACTION_TYPES_LIST:IEnumListEntry[] = [
    { id: GO_ACTION_TYPES.EAT_Place, label: "EAT_Place" },
    { id: GO_ACTION_TYPES.EAT_LevelUp, label: "EAT_LevelUp" },
    { id: GO_ACTION_TYPES.EAT_LevelDown, label: "EAT_LevelDown" },
    { id: GO_ACTION_TYPES.EAT_Remove, label: "EAT_Remove" },
    { id: GO_ACTION_TYPES.EAT_Produce, label: "EAT_Produce" },
    { id: GO_ACTION_TYPES.EAT_Repair, label: "EAT_Repair" },
    { id: GO_ACTION_TYPES.EAT_Sowing, label: "EAT_Sowing" },
    { id: GO_ACTION_TYPES.EAT_Explore, label: "EAT_Explore" }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-game-objects.ts